export enum ProductStatus {
    VipReserved = 'vipReserved',
    Sold = 'sold',
    InStock = 'inStock'
}
